import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { changePasswordRequest } from '~/store/modules/auth/actions';

export default function FormConfig({ children, code }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <Formik
      initialValues={{
        password: '',
        passwordConfirmation: '',
      }}
      onSubmit={(values, { setSubmitting }) => {
        dispatch(
          changePasswordRequest({
            password: values.password,
            code,
          })
        );
        setSubmitting(false);
      }}
      validationSchema={Yup.object().shape({
        password: Yup.string()
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.+!@#$%^&*])(?=.{8,20})/,
            t('passwordFormatValidationError')
          )
          .required(t('passwordIsRequiredValidationError')),
        passwordConfirmation: Yup.string()
          .oneOf([Yup.ref('password'), null], t('passwordsMustMatch'))
          .required(t('confirmPasswordIsRequiredValidationError')),
      })}
    >
      {children}
    </Formik>
  );
}

FormConfig.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  code: PropTypes.string,
};

FormConfig.defaultProps = { code: null };
